const { VITE_HIDE_HOME } = import.meta.env;
const Layout = () => import('@/layout/index.vue');

export default {
  path: '/',
  name: 'Home',
  component: Layout,
  // 首页隐藏时需要改成第一个页面的链接
  redirect: '/exhibitor-service-manual/download',
  meta: {
    icon: 'ep/home-filled',
    title: '首页',
    rank: 0,
  },
  children: [
    ...(VITE_HIDE_HOME !== 'true'
      ? [
          {
            path: '/welcome',
            name: 'Welcome',
            component: () => import('@/views/welcome/index.vue'),
            meta: {
              title: '首页',
              showLink: VITE_HIDE_HOME !== 'true',
            },
          },
        ]
      : []),
  ],
} satisfies RouteConfigsTable;
